<template>
    <Header
        :page-title="title"
    ></Header>
    <div class="page-content cus-content">
        <businessNav
            :nav-data="navData"
            @navClick="navClick"
        ></businessNav>
        <pageTool></pageTool>
        <div class="page-content-text" v-if="rtData.index == 0">
            <div class="page-content-text-title">{{ rtData.title }}</div>
            <div class="page-content-text-text" v-html="rtData.text"></div>
        </div>
        <div class="page-content-img" v-else-if="rtData.index == 1">
            <img v-for="(img, i) in rtData.imgs" :src="rtData.internalInstance.appContext.config.globalProperties.$imgUrl + img" :key="i">
        </div>
        <div v-else-if="rtData.index == 2">
            <div class="page-content-html">
                <div v-html="rtData.text"></div>
                <div v-if="rtData.resources.length > 0">
                    <div class="file-download" v-for="(item, i) in rtData.resources" :key="i">
                        <div>附件{{ i+1 }}：{{ item.title }}</div>
                        <a :href="rtData.internalInstance.appContext.config.globalProperties.$imgUrl + item.url">下载文件</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Header from "@/components/SNInfo/Header"
import businessNav from "@/components/nav/businessNav"
import pageTool from "@/components/nav/pageTool"
import { onMounted, reactive } from 'vue'
const banner = require('@/assets/img/page_banner_0.png')
const businessIcon0 = require('@/assets/img/business_1.png')
const businessIcon1 = require('@/assets/img/business_2.png')
const businessIcon2 = require('@/assets/img/business_0.png')
import { getProcessDetail } from '@/api/policy'
import { useRouter } from "vue-router"
import {getCurrentInstance} from "@vue/runtime-dom";
import {notification} from "ant-design-vue";
export default {
    name: "Home",
    setup() {
        const router = useRouter()
        const title = {
            cn: '备案证办理',
            en: 'Filing certificate',
            hasSearch: false,
            titleStyle: true,
            banner
        }
        const rtData = reactive({
            listData: [],
            text: '',
            title: '',
            index: 0,
            internalInstance: getCurrentInstance(),
            resources: []
        })
        const initList = async () => {
            const data = await getProcessDetail('200024&1372832566796615680')
            rtData.text = data.text
            rtData.title = data.title
            rtData.imgs = data.imgs ? data.imgs.split(',') : ''
            rtData.resources = data.resources
        }
        const navData = reactive({
            menuNames: [{name: '业务介绍', icon: businessIcon0}, {name: '业务流程', icon: businessIcon1}, {name: '业务办理', icon: businessIcon2}],
            activeName: '业务介绍'
        })
        const nameIndex = {'业务介绍': 0,'业务流程': 1,'业务办理': 2}
        const navClick = (name) => {
            // if (name == '业务流程') {
            //     router.push({ name: 'FilingProcess'})
            // } else if (name == '业务办理') {
            //     router.push({ name: 'FilingCertificate'})
            // }
            navData.activeName = name
            console.log(navData)
            rtData.index = nameIndex[name]
        }
        onMounted(() => {
            initList()
        })
        return {
            title,
            rtData,
            navData,
            nameIndex,
            navClick,
            initList
        }
    },
    components: {
        Header,
        businessNav,
        pageTool
    }
}
</script>

<style scoped lang="stylus">
.page-content {
    padding 20px 30px
    .page-content-text {
        margin-top 15px
        width 100%
        .page-content-text-title {
            width 100%
            font-size 16px
            color #6A6A6A
            font-weight bolder
        }
    }
    .page-content-img {
        margin-top 15px
        width 100%
        overflow hidden
    }
    .page-content-img img {
        width 100%
    }
    .page-block {
        .li-header {
            margin-top 20px
        }
    }
}
.page-img {
    width 100%
    padding 20px
}
.page-img img {
    width 100%
}
</style>